







































































































































































import { Component, Vue } from "vue-property-decorator";
import ExamGeneratorComponent from "@/app/components/modals/education/examGenerator.component.vue";
import BotComponent from "@/app/components/modals/education/bot.component.vue";
@Component({
  name: "education-tool-modal-component",
  components: {
    ExamGeneratorComponent,
    BotComponent,
  },
})
export default class EducationToolModalComponent extends Vue {
  showMainMenu = true;
  showChatBotMenu = false;
  showHistoryMenu = false;
  showExamGenerator = false;
  showBot = false;
  active = "tools";
  space = null;
  bots = [];
  botData = null;
  mounted(): void {}
  get viewActive() {
    const e = this.$store.getters["SystemStore/getShowEducationToolModal"];
    if (e) {
      let space = this.$store.getters["SpaceStore/getSpace"];
      let single = localStorage.getItem("single");
      if ((single && single !== "true" && space == null)) {
        this.$router.back();
        return;
      }
      this.$store.dispatch("HawkingsStore/myBundleAction", {
        callback: (response) => {
          this.bots = response.data.BOTS;
        },
        callbackError: (error) => {
          console.log("TTT myBundleAction KO ", error);
        },
      });
      this.space = this.$store.getters["SpaceStore/getSpace"];
      this.showMainMenu = true;
      this.showExamGenerator = false;
    }
    return e;
  }
  set viewActive(e) {
    this.$store.dispatch("SystemStore/setEducationToolModalAction", e);
  }
  backExam() {
    this.showMainMenu = true;
    this.showChatBotMenu = false;
    this.showHistoryMenu = false;
    this.showExamGenerator = false;
    this.showBot = false;
  }
  backBot() {
    this.showMainMenu = false;
    this.showChatBotMenu = true;
    this.showHistoryMenu = false;
    this.showExamGenerator = false;
    this.showBot = false;
  }
  showTool() {
    this.showMainMenu = true;
    this.showChatBotMenu = false;
    this.showHistoryMenu = false;
    this.showExamGenerator = false;
    this.showBot = false;
  }
  showExamGeneratorComponent() {
    this.showMainMenu = false;
    this.showChatBotMenu = false;
    this.showHistoryMenu = false;
    this.showExamGenerator = true;
    this.showBot = false;
  }
  showChatbotomponent() {
    this.showMainMenu = false;
    this.showChatBotMenu = true;
    this.showHistoryMenu = false;
    this.showExamGenerator = false;
    this.showBot = false;
  }
  showHistoryComponent() {
    this.showMainMenu = false;
    this.showChatBotMenu = false;
    this.showHistoryMenu = true;
    this.showExamGenerator = false;
    this.showBot = false;
  }
  showBotComponent(data) {
    this.botData = data;
    this.showMainMenu = false;
    this.showChatBotMenu = false;
    this.showHistoryMenu = false;
    this.showExamGenerator = false;
    this.showBot = true;
  }
  close() {
    this.viewActive = false;
    const tooltip = document.getElementsByClassName("vs-tooltip");
    if (tooltip)
      while (tooltip.length > 0) {
        tooltip[0].parentNode.removeChild(tooltip[0]);
      }
  }
  logOut() {
    this.$store.dispatch("AuthStore/logOutAction");
  }
}
